import Mandate from './Mandate';

export default Mandate; 